import { utcDayKey } from "@/lib/calendarDay";
import type { Booking } from "@/types/Booking";

const formatUtcHuman = (d: Date): string =>
  new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }).format(d);

export function filterOrgBookings(bookings: Booking[], query: string): Booking[] {
  const q = query.trim().toLowerCase();
  if (!q) return bookings;
  return bookings.filter((bk) => {
    const ref = (bk.shortCode ?? "").toLowerCase();
    const name = `${bk.member?.firstName ?? ""} ${bk.member?.lastName ?? ""}`.toLowerCase();
    const loc = (bk.location?.name ?? "").toLowerCase();
    const dateIso = bk.date ? utcDayKey(new Date(bk.date)) : "";
    const dateHuman = bk.date ? formatUtcHuman(new Date(bk.date)).toLowerCase() : "";
    return ref.includes(q) || name.includes(q) || loc.includes(q) || dateIso.includes(q) || dateHuman.includes(q);
  });
}
